import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import ReduxQuerySync from 'redux-query-sync';

import ConfigureStore from './configureStore.mjs';
import { PersistGate } from 'redux-persist/integration/react';

import ProjectList from './ProjectList';
import ProjectFilters from './ProjectFilters';

const rootContainer = document.getElementById('project-listing-app');

if (rootContainer) {
    
  const root = createRoot(rootContainer);
 
  let storeCurrent = new ConfigureStore('Project Listing', `project-listing-${rootContainer.dataset.language}`);
  let storePast = new ConfigureStore('Project Listing Past',`project-listing-past-${rootContainer.dataset.language}`);
  let translations = JSON.parse(rootContainer.dataset.translations);
    root.render(
    <div>
      <Provider store={storeCurrent.store}>
        <PersistGate loading={null} persistor={storeCurrent.persistor}>
          <ProjectList
            {...rootContainer.dataset}
            past={false}
            title={translations.onGoingProjectsHeading}
            sectionid={translations.onGoingProjectsAnchor}
          />
        </PersistGate>
      </Provider>
      <Provider store={storePast.store}>
        <PersistGate loading={null} persistor={storePast.persistor}>
          <ProjectList
            {...rootContainer.dataset}
            past={true}
            title={translations.completedProjectsHeading}
            sectionid={translations.completedProjectsAnchor}
          />
        </PersistGate>
      </Provider>
    </div>
  );
}

